import {onFind} from "@elements/init-modules-in-scope";
import {findAllIn, find} from '@elements/dom-utils';
import Tablesort from 'tablesort/src/tablesort';

let cleanNumber = function(i) {
    return i.replace(/[^\-?0-9.]/g, '');
};

let compareNumber = function(a, b) {
    a = parseFloat(a);
    b = parseFloat(b);

    a = isNaN(a) ? 0 : a;
    b = isNaN(b) ? 0 : b;

    return a - b;
};

Tablesort.extend('number', function(item) {
    return item.match(/^[-+]?[£\x24Û¢´€]?\d+\s*([,\.]\d{0,2})/) || // Prefixed currency
        item.match(/^[-+]?\d+\s*([,\.]\d{0,2})?[£\x24Û¢´€]/) || // Suffixed currency
        item.match(/^[-+]?(\d)*-?([,\.]){0,1}-?(\d)+([E,e][\-+][\d]+)?%?$/); // Number
}, function(a, b) {
    a = cleanNumber(a);
    b = cleanNumber(b);

    return compareNumber(b, a);
});

export function init() {
    onFind('.js-tablesort', function (table) {
        new Tablesort(table);

        //insert child after parent table row after sorting
        table.addEventListener('afterSort', () => {
            findAllIn('.js-tablesort__parent', table).forEach(function(parent){
                let parentId = parent.getAttribute('data-tablesort');

                findAllIn('.js-tablesort__child', table).reverse().forEach(function(child){

                    if(parentId === child.getAttribute('data-tablesort-parent')){
                        parent.parentNode.insertBefore(child, parent.nextSibling);
                    }
                });
            });
        });

        if (window.location.search) {
            let targetId = new URL(location.href).searchParams.get('order_id'),
                target = find('#'+ targetId +'');

            window.scrollTo({
                top: target.offsetTop + find('.js-nav-container').getBoundingClientRect().height - 20,
                behavior: 'smooth'
            });
        }
    });
}